import React from "react";
import { motion } from "framer-motion";
import { site } from "@/lib/siteContent";

export default function Journey() {
  const items = site.journey;
  return (
    <section
      id="journey"
      data-testid="journey-section"
      className="relative bg-white py-24 lg:py-32 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-3xl mb-16 lg:mb-24"
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-12 bg-gold" />
            <span className="text-[11px] font-bold uppercase tracking-[0.32em] text-gold-dark">
              Our Journey
            </span>
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-navy font-medium leading-[1.05] tracking-tight">
            Two decades.<br />
            One <span className="italic text-gold-dark">unwavering vision.</span>
          </h2>
        </motion.div>

        {/* Horizontal timeline */}
        <div className="relative">
          {/* Line */}
          <div className="absolute left-0 right-0 top-[42px] h-px bg-navy/10 hidden md:block" />
          <motion.div
            initial={{ scaleX: 0 }}
            whileInView={{ scaleX: 1 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1] }}
            style={{ transformOrigin: "left" }}
            className="absolute left-0 right-0 top-[42px] h-[2px] bg-gradient-to-r from-gold via-gold-dark to-gold/20 hidden md:block"
          />

          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-y-12 md:gap-x-4">
            {items.map((m, i) => (
              <motion.div
                key={m.year}
                data-testid={`journey-${i}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ delay: 0.15 + i * 0.12, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                className="relative md:pr-4"
              >
                {/* Dot */}
                <div className="hidden md:flex items-center justify-center w-[22px] h-[22px] rounded-full bg-white border-2 border-gold relative z-10 mb-6 ml-0">
                  <div className="w-2 h-2 rounded-full bg-gold" />
                </div>
                <div className="md:hidden flex items-center gap-3 mb-3">
                  <div className="w-2 h-2 rounded-full bg-gold" />
                  <div className="h-px w-10 bg-gold/40" />
                </div>
                <div className="font-display text-2xl lg:text-3xl text-navy font-semibold leading-none">
                  {m.year}
                </div>
                <div className="mt-2 text-[11px] font-bold uppercase tracking-[0.22em] text-gold-dark">
                  {m.title}
                </div>
                <p className="mt-3 text-sm text-navy/65 leading-relaxed max-w-[200px]">
                  {m.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
